import React, { Component, PropTypes } from 'react';
import { RaisedButton, TextField, Styles } from 'material-ui';
import Spinner from 'components/Material/Spinner';
import CoursioLogo from 'components/CoursioLogo';
import { FormattedMessage } from 'react-intl';
import LoginForm from 'components/LoginForm';
import { AuthActions } from 'actions';
import Css from 'Css';
import { mixin, RefluxMixin } from 'Util';
import { StoreOverviewStore } from 'stores';
const isValidEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

const { Units, Colors } = Css;

const css = oxygenCss({
  root: {
    position: 'relative'
  },
  logoWrapper: {
    paddingTop: Units.base * 2,
    paddingBottom: Units.base * 2,
    textAlign: 'center'
  },
  logoContainer: {
    color: '#7e7e7e',
    border: 'solid 1px #7e7e7e',
    borderRadius: 80,
    display: 'inline-block',
    fontSize: 11,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.31,
    letterSpacing: '0.1px',
    padding: Units.base,
    ' SVG': {
      verticalAlign: 'middle',
      marginLeft: 8,
      marginRight: 4
    }
  },
  headerWrapper: {
    paddingTop: Units.base,
    paddingBottom: Units.base
  },
  header: {
    fontSize: '1.5em',
    lineHeight: '1.5em',
    color: Colors.material.grey[500].material,
    padding: '0 0 0.5em 0',
    margin: 0,
    textAlign: 'center',
    paddingTop: '40px'
  }
});

export default class RegisterForm extends mixin(RefluxMixin, Component) {
  static propTypes = {
    onLogin: PropTypes.func,
    store: PropTypes.string,
    userEmail: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    login: false,
    password: null,
    firstname: null,
    lastname: null,
    email: this.props.userEmail,
    emailError: null,
    nameError: null,
    passwordError: null
  };

  listenToStores() {
    this.listenToStoreWithMapper(StoreOverviewStore, state => {
      return {
        store: state.name
      };
    });
  }

  reset() {
    this.setState({ login: false });
  }

  login() {
    if (this.props.onLogin) {
      this.props.onLogin();
    }
  }

  loginForm() {
    this.setState({ login: true });
  }

  validEmail(email) {
    return isValidEmail.test(email.toLowerCase());
  }

  _handleEmailChange = event => {
    const { value: email } = event.target;
    if (!this.validEmail(email)) {
      this.setState({
        email,
        emailError: this.context.getIntlMessage('validation.invalidEmail')
      });
    } else {
      this.setState({ email, emailError: null });
    }
  };

  _handlePasswordChange = event => {
    const { value: password } = event.target;
    if (password === '' || password === null) {
      this.setState({
        password,
        passwordError: this.context.getIntlMessage('validation.required')
      });
    } else if (password.length < 6) {
      this.setState({
        password,
        passwordError: this.context.getIntlMessage(
          'validation.passwordTooShort'
        )
      });
    } else {
      this.setState({ password, passwordError: null, empty: false });
    }
  };

  _handleNameChange = e => {
    if (e.target.value === '' || e.target.value === null) {
      this.setState({
        [e.target.name]: e.target.value,
        nameError: this.context.getIntlMessage('validation.required')
      });
    } else {
      this.setState({ [e.target.name]: e.target.value, nameError: null });
    }
  };

  onTac = () => {
    const { onTac } = this.props;
    onTac && onTac();
  };

  register = () => {
    const { firstname, lastname, email, password } = this.state;
    const { userLocale } = this.props;
    AuthActions.register(email, password, firstname, lastname, userLocale);
  };

  render() {
    const {
      emailError,
      passwordError,
      nameError,
      login,
      firstname,
      lastname,
      email,
      password,
      store
    } = this.state;
    const { userEmail, hash, userName, userLocale, router } = this.props;
    const { getIntlMessage } = this.context;
    if (login) {
      return <LoginForm router={router} onLogin={this.login.bind(this)} />;
    }
    const canRegister =
      password &&
      !passwordError &&
      email &&
      !emailError &&
      firstname &&
      lastname &&
      !nameError;

    let button, tocContents;

    if (this.state.loading) {
      button = (
        <RaisedButton fullWidth secondary disabled>
          <Spinner />
        </RaisedButton>
      );
    } else {
      button = (
        <RaisedButton
          disabled={!canRegister}
          fullWidth
          label={this.context.getIntlMessage('Register')}
          secondary
          onTouchTap={this.register}
        />
      );
    }

    tocContents = (
      <a href={'#'} onTouchTap={() => this.onTac()}>
        {this.context.getIntlMessage('toc.toc')}
      </a>
    );

    return (
      <div className='login'>
        <form>
          <h1 className={css.header}>
            {this.props.title || this.context.getIntlMessage('account.need')}
          </h1>
          <div>
            <TextField
              fullWidth
              onChange={this._handleNameChange}
              autoFocus
              hintText={this.context.getIntlMessage('firstname')}
              errorText={nameError}
              type='text'
              value={firstname}
              name='firstname'
            />
            <TextField
              fullWidth
              onChange={this._handleNameChange}
              autoFocus
              hintText={this.context.getIntlMessage('lastname')}
              errorText={nameError}
              type='text'
              value={lastname}
              name='lastname'
            />
            <TextField
              onChange={this._handleEmailChange}
              hintText={this.context.getIntlMessage('Email')}
              errorText={emailError}
              fullWidth
              value={email}
              disabled={!!userEmail}
              type='text'
            />
            <TextField
              fullWidth
              errorText={passwordError}
              onChange={this._handlePasswordChange}
              hintText={this.context.getIntlMessage('Password')}
              value={password}
              type='password'
            />
          </div>
          {button}
          <FormattedMessage
            message={this.context.getIntlMessage('toc.accept')}
            toc={tocContents}
          />
        </form>
        <div className={css.headerWrapper}>
          <h1 className={css.header}>
            {this.context.getIntlMessage('account.have')}
          </h1>
        </div>
        <RaisedButton
          fullWidth
          secondary
          label={this.context.getIntlMessage('Login')}
          onTouchTap={this.loginForm.bind(this)}
        />
        <div className={css.logoWrapper}>
          <div className={css.logoContainer}>
            <FormattedMessage
              message={getIntlMessage('poweredBy')}
              engine={
                <span>
                  {' '}
                  <CoursioLogo width={16} initialFill={'#7e7e7e'} />
                  coursio
                </span>
              }
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/RegisterForm.js